// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@ces/XDL/Utilities";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface SearchFieldWrapperStyles {
    wrapper?: InjectableCss;
}

export const searchFieldWrapperStyles: SearchFieldWrapperStyles = {
    wrapper: {
        css: css`
            padding: 10px;
            width: 100%;
        `,
    },
};

const SearchFieldWrapper: React.FC<{ extendedStyles?: SearchFieldWrapperStyles }> = ({ children, extendedStyles }) => {
    /**
     * XNG-Changes:
     * OOTB issue: does not read from extendedStyles changed from extendedStyles to extendedStyles?.wrapper
     */
    const styles = mergeWithCss(searchFieldWrapperStyles.wrapper, extendedStyles?.wrapper);
    return <StyledWrapper {...styles}>{children}</StyledWrapper>;
};

export default SearchFieldWrapper;
